import React from "react";

import ExportablesTemplateHeaderSection from "@/components/AIComponents/ExportablesModal/templates/components/ExportablesTemplateHeaderSection";
import { INPUT_MAX_LENGTH } from "../../../ExportablesEditor/ExportablesEditor.constants";
import { TemplateProps } from "../../registry";
import * as styles from "./CompareContrastOrganizer.styles";
import OrganizerCircleTextArea from "./OrganizerCircleTextArea";
import { updateTopic } from "./utils";

export interface CompareContrastData {
  article_title?: string;
  topic_pairs?: string[][];
  leftTopic?: string;
  rightTopic?: string;
  leftSection?: string;
  rightSection?: string;
  centerSection?: string;
  editMode?: boolean;
}

const CompareContrastOrganizer: React.FC<
  TemplateProps<CompareContrastData>
> = ({ formData, onChange, title = "Compare and Contrast" }) => {
  const data = formData as CompareContrastData;
  const leftTopic = data?.topic_pairs?.[0]?.[0] || "";
  const rightTopic = data?.topic_pairs?.[0]?.[1] || "";
  const leftSection = data?.topic_pairs?.[0]?.[2] || "";
  const rightSection = data?.topic_pairs?.[0]?.[3] || "";
  const centerSection = data?.topic_pairs?.[0]?.[4] || "";

  const handler = (
    section:
      | "left-topic"
      | "right-topic"
      | "left-section"
      | "right-section"
      | "center-section",
  ) => {
    return (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
      updateTopic(section, e.target.value, onChange, formData);
  };

  const renderTopicsSection = () => (
    <div css={styles.bothSectionContainer}>
      <div css={styles.inputsRow}>
        <div css={styles.bottomLineInputWrapper}>
          <input
            type="text"
            data-qa-selector="organizer-left-topic"
            id="organizer-left-topic"
            value={leftTopic.substring(0, INPUT_MAX_LENGTH)}
            maxLength={INPUT_MAX_LENGTH}
            onChange={handler("left-topic")}
            css={styles.bottomLineInput}
            aria-label="Left Topic"
            placeholder="Left Topic"
          />
        </div>
        <div css={styles.bothLabel}>Both</div>
        <div css={styles.bottomLineInputWrapper}>
          <input
            type="text"
            data-qa-selector="organizer-right-topic"
            id="organizer-right-topic"
            value={rightTopic.substring(0, INPUT_MAX_LENGTH)}
            maxLength={INPUT_MAX_LENGTH}
            onChange={handler("right-topic")}
            css={styles.bottomLineInput}
            aria-label="Right Topic"
            placeholder="Right Topic"
          />
        </div>
      </div>
    </div>
  );

  const renderVennDiagramSection = () => {
    return (
      <div css={styles.vennDiagramContainer}>
        <div css={styles.circleLeft} />
        <div css={styles.circleRight} />
        <div css={styles.vennDiagramTextAreaContainer}>
          <OrganizerCircleTextArea
            section="left"
            value={leftSection}
            onChange={handler("left-section")}
          />
          <OrganizerCircleTextArea
            section="center"
            value={centerSection}
            onChange={handler("center-section")}
          />
          <OrganizerCircleTextArea
            section="right"
            value={rightSection}
            onChange={handler("right-section")}
          />
        </div>
      </div>
    );
  };

  const renderHeader = () => (
    <ExportablesTemplateHeaderSection
      templateTitle={title}
      articleTitle={formData?.article_title}
    />
  );

  return (
    <form
      css={styles.compareContrastContainer}
      aria-label="Compare Contrast Organizer"
    >
      {renderHeader()}
      {renderTopicsSection()}
      {renderVennDiagramSection()}
    </form>
  );
};

export default CompareContrastOrganizer;
